import * as yup from 'yup';

const currencyRegex = /^\d{1,},\d{2}$/;
const ncmRegex = /^\d{4}\.\d{2}\.\d{2}$/;

yup.addMethod(yup.string, 'currency', function () {
  return this.test('currency', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && currencyRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid currency' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'ncm', function () {
  return this.test('ncm', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && ncmRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid ncm' }));
      }
    });
  });
});

const schema = yup.object().shape({
  code: yup
    .string()
    .ncm()
    .trim(),
  nacionalAliquot: yup
    .string()
    .required()
    .currency(),
  importationAliquot: yup
    .string()
    .required()
    .currency(),
  description: yup
    .string()
    .required()
    .trim()
});

export default schema;
